module.exports = __webpack_public_path__ + "img/platforms.372131ad.png";